/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Male
 * 
 * 1 = Female
 * 
 * 2 = Other
 */
export enum Gender {
  Male = 0,
  Female = 1,
  Other = 2
}
